<template>
  <div id="documenting">
    <projectTable
      :operateColumns="operateColumns"
      ref="projectTable"
      :extraQuery="extraQuery"
      :extraSearch="extraSearch"
    ></projectTable>
    <Modal
      v-model="editGroupVisible"
      title="项目开标后"
      width="1100px"
      :mask-closable="false"
      :styles="{top: '50px'}"
    >
      <after-bid
        :projectData="projectData"
      ></after-bid>
      <div slot="footer">
        <Button @click="editGroupVisible=false">取消</Button>
      </div>
    </Modal>
    <detail-modify
      :projectData="projectData"
      :medal="projectEditVisible"
      @medal_ch="change_medal"
      :editType="editType"
      @reviseManager="reviseManager"
      @addManager="addManager"
      ref="detailModify"
    > </detail-modify>
    <Modal
      class="finanicalflow-modal"
      v-model="financialVisible"
      title="财务一览"
      width="1350"
      :scrollable="true"
    >
      <financial-flows :projectData="projectData" :agreement="agreement"></financial-flows>
      <div slot="footer">
        <Button @click="financialVisible=false">取消</Button>
      </div>
    </Modal>
    <Modal
      title="备注"
      v-model="remarkVisible"
    >
      <Input v-model="projectData.comment"></Input>
      <div slot="footer">
        <Button @click="remarkVisible=false">取消</Button>
        <Button
          @click="reviseRemark"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import projectTable from '@/components/projectTable'
import ajax from '@/lib/ajax'
import AfterBid from "./afterBid/afterBid.vue"
import requestUrls from '@/lib/requestUrls'
import FinancialFlows from './financialFlows'//财务流
// import DepositExpand from '@/views/financialFlows/depositExpand'
import DetailModify from "@/views/projectCenter/projectModify/detailModify.vue"

export default {
  name: 'projectFlow',
  data() {
    return {
      printUrl: '',
      financialVisible: false,
      projectEditVisible: false,
      editType: 'projectEdit',
      remarkVisible: false,
      operateColumns: [
        {
          title: '报名截止时间',
          width: 108,
          render: (h, params) => {
            let time = '暂无'
            if (params.row.applyEnd) {
              time = params.row.applyEnd.replace('T', ' ')
            }
            return h('div', time)
          }
        },
        {
          title: '客户经理',
          width: 108,
          render: (h, params) => {
            return h('div', params.row.am)
          }
        },
        {
          title: '项目助理',
          width: 108,
          render: (h, params) => {
            return h('div', params.row.aid)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 330,
          render: (h, params) => {
            let disabled1 = true
            let disabled2 = true
            let disabled3 = true
            let disabled4 = true
            if (params.row.projectState === '审查通过可挂网' || params.row.projectState === '已挂网文件售卖中' || params.row.projectState === '开评标中'
              || params.row.projectState === '等待用户需求' || params.row.projectState === '文件编制中') {
              disabled1 = false
            }
            if (params.row.projectState === '已挂网文件售卖中' || params.row.projectState === '开评标中' || params.row.projectState === '已开评标完') {
              disabled2 = false
            }
            if (params.row.projectState === '审查通过可挂网' || params.row.projectState === '开评标中'
              || params.row.projectState === '等待用户需求' || params.row.projectState === '文件编制中' || params.row.projectState === '标书文件已完成') {
              disabled3 = false
            }
            if (params.row.projectState === '已挂网文件售卖中' || params.row.projectState === '开评标中' || params.row.projectState === '已开评标完' || params.row.projectState === '项目结项' || params.row.projectState === '项目失败') {
              disabled4 = false
            }
            let projectDisplay = ['inline-block', 'none']
            if (disabled1 && disabled2) {
              projectDisplay = projectDisplay.reverse()
            }
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      this.editGroupVisible = true
                    }
                  }
                }, '项目信息'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: disabled4
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      this.financialVisible = true
                      ajax.get(requestUrls.CLTrustAgreementInfo.GetPaged, {
                        params: {
                          filter: `projectId == ${params.row.id}`
                        }
                      }).then(res => {
                        this.agreement = res.data.result.items
                      })
                    }
                  }
                }, '财务一览'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: disabled3
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: async () => {
                      if (!this.projectEditPermission) {
                        this.$Message.error('无权限')
                        return
                      }
                      this.$Spin.show()
                      switch (params.row.projectState) {
                        case '等待用户需求':
                        case '文件编制中':
                        case '标书文件已完成':
                        case '审查通过可挂网':
                          this.$Spin.hide()
                          this.projectData = params.row
                          this.projectEditVisible = true
                          break
                        default: 
                          this.$Spin.hide()
                          this.$Message.warning('项目已挂网，不可修改')
                      }
                    }
                  }
                }, '项目编辑'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      this.remarkVisible = true
                    }
                  }
                }, '备注'),
              ])
          }
        },
      ],
      // editProject: 'projectList',
      projectData: {},
      // 项目状态筛选
      extraQuery: {
        status: '',
        rolePermission: ''
      },
      editGroupVisible: false,
      extraSearch: {
        searchModify: true
      },
      agreement: []
    }
  },
  components: {
    projectTable,
    AfterBid,//开标后
    DetailModify, // 项目编辑
    FinancialFlows
  },
  computed: {
    projectEditPermission() {
      return this.$store.getters['session/hasRoles']('分公司项目经理') || this.$store.getters['session/hasRoles']('分公司客户经理')
    }
  },
  methods: {
    change_medal(val) {
      //改变模态框的值
      this.projectEditVisible = val;
    },
    reviseRemark() {
      this.$Modal.confirm({
        title: '修改备注',
        content: '确定修改备注信息？',
        onOk: async () => {
          try {
            this.$Spin.show()
            let rep = await ajax.post(requestUrls.ClProjectDb.CreateOrUpdate, {
              clProjectDb: this.projectData
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('修改成功')
              this.remarkVisible = false
            } else {
              this.$Message.error('修改失败')
            }
          } catch (err) {
            this.$Spin.hide()
            console.error(err)
            this.$Message.error('修改失败')
          }
        }
      })
    },
    reviseManager(val) {
      this.projectData.am = val
      this.$refs.detailModify.addManagerVisible = false
    },
    addManager(val) {
      this.projectData.am += `,${val}`
      this.$refs.detailModify.addManagerVisible = false
    }
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'projectFlow') {
        this.$refs.projectTable.refreshProject()
      }
    }
  },
}
</script>

<style lang="less">
.finanicalflow-modal {
  .ivu-modal {
    top: 20px;
  }
}
</style>
